// Product api

const Product = 
    [
        {id : 1 , 
        name: "Shirt" , 
        price : "15.55" , 
        state : "Top" , 
        img: "imgFour.jpg" ,
        details: {
            description: " hello"
        }
      },
       {id : 2 , 
        name: "Big Shirt" , 
        price : "120.00" , 
        state : "Sale" , 
        img: "imgtow.jpg" ,
      },
       {id : 3 , 
        name: "mediom Shirt" , 
        price : "152.00" , 
        state : "Sale" , 
        img: "imgFour.jpg" ,
      },
       {id : 4 , 
        name: "Switcher Blue" , 
        price : "18.00" , 
        state : "Sale" , 
        img: "imgtow.jpg" ,
      },
      
      
  
    ]

module.exports.Product = Product
